/* ==========================================================================
   Rose & Marie — Slide-cart
   Houdt de verzendbalk en de upsell in de winkelwagenlade in sync met de cart.

   Sync-signalen (alle drie, zodat niets gemist wordt):
     - 'ajaxProduct:added'  -> na toevoegen vanaf een productpagina / quick add
     - 'cart:updated'       -> na een aantalswijziging in de lade of op /cart
     - MutationObserver op [data-products] -> vangt elke herbouw van de lade op

   Er wordt niets van theme.js overschreven; dit bestand leest alleen /cart.js.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('CartDrawer');
  var configEl = document.getElementById('EmSlideCartConfig');
  if (!root || !configEl) return;

  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var els = {
    ship: root.querySelector('[data-emsc-ship]'),
    shipText: root.querySelector('[data-emsc-ship-text]'),
    shipTrack: root.querySelector('[data-emsc-ship-track]'),
    shipFill: root.querySelector('[data-emsc-ship-fill]'),
    upsell: root.querySelector('[data-emsc-upsell]'),
    upsellRow: root.querySelector('[data-emsc-upsell-row]'),
    upsellNav: root.querySelector('[data-emsc-nav]'),
    tiers: root.querySelector('[data-emsc-tiers]'),
    tiersText: root.querySelector('[data-emsc-tiers-text]'),
    tiersFill: root.querySelector('[data-emsc-tiers-fill]'),
    tiersDots: root.querySelector('[data-emsc-tiers-dots]'),
    tiersLabels: root.querySelector('[data-emsc-tiers-labels]'),
    products: root.querySelector('[data-products]')
  };

  var state = { upsellKey: null, busy: false, upPage: 0 };

  /* ---------------------------------------------------------------- utils */

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Prijzen komen als integer (recommendations API) of als "49.95" (products.json).
  function toCents(value) {
    if (typeof value === 'number') return Math.round(value);
    var n = parseFloat(String(value).replace(',', '.'));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function sized(url, width) {
    if (!url) return '';
    var abs = url.indexOf('//') === 0 ? 'https:' + url : url;
    return abs + (abs.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------ verzending */

  /* ----------------------------------------------------------- staffel  */

  // Actieve tredes, oplopend gesorteerd. qty 0 = trede uitgeschakeld.
  var TIERS = (cfg.tiers || [])
    .filter(function (t) { return t && t.qty > 0 && t.pct > 0; })
    .sort(function (a, b) { return a.qty - b.qty; });

  // Frans zet een vaste spatie voor het procentteken.
  function pct(n) {
    return n + ' %';
  }

  // Tredes staan gelijkmatig verdeeld; de laatste altijd op 100%.
  function stopAt(i) {
    return ((i + 1) / TIERS.length) * 100;
  }

  // De vulling loopt lineair van trede naar trede, niet van 0 tot de laatste.
  function fillPercent(qty) {
    if (qty <= 0) return 0;
    var prevQty = 0;
    var prevPos = 0;
    for (var i = 0; i < TIERS.length; i++) {
      if (qty < TIERS[i].qty) {
        var frac = (qty - prevQty) / (TIERS[i].qty - prevQty);
        return prevPos + frac * (stopAt(i) - prevPos);
      }
      prevQty = TIERS[i].qty;
      prevPos = stopAt(i);
    }
    return 100;
  }

  function buildScale(qty) {
    var dots = '';
    var labels = '';
    TIERS.forEach(function (t, i) {
      var pos = stopAt(i);
      var done = qty >= t.qty;
      // Het laatste label rechts uitlijnen, anders steekt het buiten de balk.
      var shift = pos >= 100 ? 'translateX(-100%)' : 'translateX(-50%)';
      dots += '<span class="emsc-tiers__dot' + (done ? ' is-done' : '') +
              '" style="left:' + pos + '%"></span>';
      labels += '<span class="emsc-tiers__label' + (done ? ' is-done' : '') +
                '" style="left:' + pos + '%;transform:' + shift + '">-' + pct(t.pct) + '</span>';
    });
    if (els.tiersDots) els.tiersDots.innerHTML = dots;
    if (els.tiersLabels) els.tiersLabels.innerHTML = labels;
  }

  function renderTiers(cart) {
    if (!els.tiers) return;

    var qty = cart.item_count;
    if (!cfg.tiersEnabled || !TIERS.length || qty === 0) {
      els.tiers.classList.add('emsc-hidden');
      return;
    }

    // Wat Shopify daadwerkelijk toepast is de waarheid, niet onze aanname.
    var applied = (cart.cart_level_discount_applications || [])[0];
    var appliedPct = applied ? Math.round(parseFloat(applied.value)) : 0;

    // Hoort er korting te zijn maar past Shopify niets toe (korting uitgezet,
    // verlopen of gewijzigd)? Dan de balk verbergen in plaats van iets beloven.
    if (qty >= TIERS[0].qty && !applied) {
      els.tiers.classList.add('emsc-hidden');
      return;
    }

    els.tiers.classList.remove('emsc-hidden');

    var next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (qty < TIERS[i].qty) { next = TIERS[i]; break; }
    }

    var tekst;
    if (next) {
      var need = next.qty - qty;
      var tpl = need === 1 ? cfg.tierOne : cfg.tierMany;
      tekst = String(tpl || '')
        .replace('[n]', '<strong>' + need + '</strong>')
        .replace('[pct]', '<strong>' + pct(next.pct) + '</strong>');
    } else {
      // Bereikt: toon het percentage dat de winkelwagen echt heeft.
      tekst = String(cfg.tierReached || '')
        .replace('[pct]', '<strong>' + pct(appliedPct || TIERS[TIERS.length - 1].pct) + '</strong>');
    }

    els.tiersText.innerHTML = tekst;
    els.tiers.classList.toggle('emsc-tiers--max', !next);
    if (els.tiersFill) els.tiersFill.style.width = fillPercent(qty) + '%';
    buildScale(qty);
  }

  function renderShipping(cart) {
    if (!els.ship) return;

    if (cfg.shipMode === 'off' || cart.item_count === 0) {
      els.ship.classList.add('emsc-hidden');
      return;
    }
    els.ship.classList.remove('emsc-hidden');

    var threshold = cfg.thresholdCents;

    if (cfg.shipMode === 'always_free' || !threshold || cart.total_price >= threshold) {
      els.ship.classList.add('emsc-ship--free');
      els.shipText.innerHTML = cfg.textFree;
      if (els.shipTrack) {
        els.shipTrack.classList.toggle('emsc-hidden', cfg.shipMode === 'always_free');
        if (els.shipFill) els.shipFill.style.width = '100%';
      }
      return;
    }

    var remaining = threshold - cart.total_price;
    els.ship.classList.remove('emsc-ship--free');
    els.shipText.innerHTML = cfg.textProgress.replace('[amount]', '<strong>' + money(remaining) + '</strong>');
    if (els.shipTrack) els.shipTrack.classList.remove('emsc-hidden');
    if (els.shipFill) {
      els.shipFill.style.width = Math.max(2, Math.min(100, (cart.total_price / threshold) * 100)) + '%';
    }
  }

  /* ---------------------------------------------------------------- upsell */

  function normalize(p) {
    var image = p.featured_image;
    if (image && typeof image === 'object') image = image.src;
    if (!image && p.images && p.images.length) {
      image = typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src;
    }

    // /recommendations geeft de prijs in centen op productniveau,
    // /collections/*/products.json alleen als decimale string per variant.
    var prijs = toCents(p.price != null ? p.price : p.price_min);
    var vergelijk = toCents(p.compare_at_price || p.compare_at_price_min || 0);
    if (!prijs && p.variants && p.variants.length) {
      var goedkoopste = p.variants.reduce(function (a, b) {
        return toCents(b.price) < toCents(a.price) ? b : a;
      });
      prijs = toCents(goedkoopste.price);
      if (!vergelijk) vergelijk = toCents(goedkoopste.compare_at_price || 0);
    }

    return {
      id: p.id,
      title: p.title,
      type: p.product_type || '',
      url: p.url || '/products/' + p.handle,
      image: image,
      price: prijs,
      compareAt: vergelijk,
      options: (p.options || []).map(function (o) {
        return typeof o === 'string' ? { name: o, values: [] } : { name: o.name, values: o.values || [] };
      }),
      variants: (p.variants || []).map(function (v) {
        return {
          id: v.id,
          title: v.title,
          available: v.available !== false,
          price: toCents(v.price),
          opts: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; })
        };
      })
    };
  }

  // Complementair -> gerelateerd; te weinig resultaten worden aangevuld
  // vanuit de terugvalcollectie, zodat de rij nooit half leeg blijft.
  function fetchSuggestions(productId, need) {
    var base = '/recommendations/products.json?limit=10&product_id=' + productId + '&intent=';

    return getJSON(base + 'complementary')
      .catch(function () { return {}; })
      .then(function (d) {
        if (d.products && d.products.length) return d.products;
        return getJSON(base + 'related')
          .then(function (d2) { return (d2 && d2.products) || []; })
          .catch(function () { return []; });
      })
      .then(function (list) {
        if (list.length >= need) return list;
        return getJSON('/collections/' + (cfg.fallbackCollection || 'all') + '/products.json?limit=24')
          .then(function (d) {
            var seen = {};
            list.forEach(function (p) { seen[p.id] = 1; });
            ((d && d.products) || []).forEach(function (p) {
              if (!seen[p.id]) { seen[p.id] = 1; list.push(p); }
            });
            return list;
          })
          .catch(function () { return list; });
      });
  }

  // Voorstellen uit ANDERE collecties dan wat er al in de winkelwagen ligt.
  // In deze winkel valt product_type samen met de collectie, dus daar filteren
  // we op: dat scheelt een verzoek per collectie.
  function crossSellPool(cartTypes, inCart) {
    return getJSON('/collections/all/products.json?limit=250')
      .then(function (d) {
        var byType = {};
        ((d && d.products) || []).forEach(function (p) {
          var t = p.product_type || '';
          if (cartTypes.indexOf(t) !== -1) return;
          if (inCart.indexOf(p.id) !== -1) return;
          (byType[t] = byType[t] || []).push(p);
        });

        // Om de beurt uit elke overgebleven collectie, anders bestaat de hele
        // rij uit de grootste collectie.
        var buckets = Object.keys(byType).map(function (t) { return byType[t]; });
        var out = [];
        for (var i = 0; buckets.length; i++) {
          var gevonden = false;
          for (var b = 0; b < buckets.length; b++) {
            if (buckets[b][i]) { out.push(buckets[b][i]); gevonden = true; }
          }
          if (!gevonden || out.length >= 24) break;
        }
        return out;
      })
      .catch(function () { return []; });
  }

  function renderUpsell(cart) {
    if (!els.upsell || !cfg.upsellEnabled) return;

    if (cart.item_count === 0) {
      els.upsell.classList.add('emsc-hidden');
      state.upsellKey = null;
      return;
    }

    // Shopify zet een net toegevoegd artikel vooraan in cart.items, niet achteraan
    // (nagemeten op deze winkel) — items[0] is dus het meest recente.
    var last = cart.items[0];
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var key = last.product_id + ':' + inCart.slice().sort().join(',');
    if (key === state.upsellKey) return;
    state.upsellKey = key;

    // Collecties die al in de winkelwagen zitten — daar willen we niet meer van tonen.
    var cartTypes = cart.items
      .map(function (i) { return i.product_type || ''; })
      .filter(function (t, i, a) { return a.indexOf(t) === i; });

    var bron = cfg.upsellCross
      ? crossSellPool(cartTypes, inCart)
      : fetchSuggestions(last.product_id, cfg.upsellLimit + inCart.length);

    bron.then(function (raw) {
      var items = raw
        .map(normalize)
        .filter(function (p) {
          if (inCart.indexOf(p.id) !== -1) return false;
          if (!p.variants.some(function (v) { return v.available; })) return false;
          // Ook bij de aanbevelingsbron: nooit dezelfde collectie terugtonen.
          if (cfg.upsellCross && cartTypes.indexOf(p.type) !== -1) return false;
          return true;
        })
        .slice(0, cfg.upsellLimit);

      if (!items.length) {
        els.upsell.classList.add('emsc-hidden');
        return;
      }

      els.upsellRow._items = items;
      state.upPage = 0;
      paintUpsell();
      els.upsell.classList.remove('emsc-hidden');
    });
  }

  // Toont één pagina van de suggesties; de pijlen lopen rond.
  function paintUpsell() {
    var items = (els.upsellRow && els.upsellRow._items) || [];
    var per = Math.max(1, cfg.upsellPerPage || 2);
    var paginas = Math.ceil(items.length / per);
    if (!paginas) return;

    state.upPage = ((state.upPage % paginas) + paginas) % paginas;
    var deel = items.slice(state.upPage * per, state.upPage * per + per);

    els.upsellRow.innerHTML = deel.map(card).join('');
    els.upsellRow.querySelectorAll('.emsc-up').forEach(function (kaart) {
      var p = findProduct(kaart.dataset.emscId);
      if (p) ververOpties(kaart, p);
    });
    if (els.upsellNav) els.upsellNav.classList.toggle('emsc-hidden', paginas < 2);
  }

  // Opties met maar één waarde kiezen we stil; alleen echte keuzes krijgen een
  // uitklaplijst, zoals op de PDP.
  function keuzeOpties(p) {
    return p.options
      .map(function (o, i) { return { naam: o.name, waarden: o.values, index: i }; })
      .filter(function (o) { return o.waarden.length > 1; });
  }

  // Bestaat er een leverbare variant met deze waarde, gegeven de rest van de keuze?
  function waardeKan(p, index, waarde, gekozen) {
    return p.variants.some(function (v) {
      if (!v.available) return false;
      if (v.opts[index] !== waarde) return false;
      return gekozen.every(function (g, i) { return i === index || !g || v.opts[i] === g; });
    });
  }

  function gekozenVan(kaart, p) {
    var uit = p.options.map(function (o) { return o.values.length === 1 ? o.values[0] : ''; });
    kaart.querySelectorAll('[data-emsc-opt]').forEach(function (sel) {
      uit[+sel.dataset.emscOpt] = sel.value;
    });
    return uit;
  }

  function variantVan(p, gekozen) {
    if (gekozen.some(function (g) { return !g; })) return null;
    return p.variants.find(function (v) {
      return v.available && gekozen.every(function (g, i) { return v.opts[i] === g; });
    }) || null;
  }

  // Waarden die niet meer combineerbaar zijn, blokkeren we in plaats van ze te
  // verbergen — anders lijkt het aanbod kleiner dan het is.
  function ververOpties(kaart, p) {
    var gekozen = gekozenVan(kaart, p);
    kaart.querySelectorAll('[data-emsc-opt]').forEach(function (sel) {
      var index = +sel.dataset.emscOpt;
      sel.querySelectorAll('option[value]').forEach(function (opt) {
        if (!opt.value) return;
        var kan = waardeKan(p, index, opt.value, gekozen);
        opt.disabled = !kan;
        var basis = opt.dataset.label || opt.textContent;
        opt.dataset.label = basis;
        opt.textContent = kan ? basis : basis + ' — ' + cfg.soldOutText;
      });
    });
    var knop = kaart.querySelector('[data-emsc-add]');
    if (knop) knop.classList.toggle('is-incompleet', !variantVan(p, gekozen));
  }

  function card(p) {
    // Volgorde zoals in de rest van de lade: doorgestreept grijs eerst, dan de
    // prijs in rood.
    var prijs = '<span class="emsc-up__price">' +
      (p.compareAt > p.price ? '<s>' + money(p.compareAt) + '</s>' : '') +
      '<b>' + money(p.price) + '</b></span>';

    var besparing = '';
    if (p.compareAt > p.price && cfg.saveText) {
      besparing = '<span class="emsc-up__save">' +
        String(cfg.saveText).replace('[amount]', money(p.compareAt - p.price)) + '</span>';
    }

    var opties = keuzeOpties(p).map(function (o) {
      var keuzes = o.waarden.map(function (w) {
        return '<option value="' + esc(w) + '">' + esc(w) + '</option>';
      }).join('');
      return '<span class="emsc-up__opt">' +
        '<select data-emsc-opt="' + o.index + '" aria-label="' + esc(o.naam) + '">' +
          '<option value="">' + esc(o.naam) + '</option>' + keuzes +
        '</select></span>';
    }).join('');

    return '<div class="emsc-up" data-emsc-id="' + p.id + '">' +
      '<a class="emsc-up__media" href="' + esc(p.url) + '" tabindex="-1">' +
        '<img class="emsc-up__img" src="' + esc(sized(p.image, 240)) + '" alt="' + esc(p.title) + '" loading="lazy" width="76" height="101">' +
      '</a>' +
      '<div class="emsc-up__body">' +
        '<a class="emsc-up__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        prijs + besparing +
        (opties ? '<div class="emsc-up__opts">' + opties + '</div>' : '') +
        '<button type="button" class="emsc-up__btn" data-emsc-add="' + p.id + '">' + esc(cfg.upsellCta) + '</button>' +
      '</div>' +
    '</div>';
  }

  function findProduct(id) {
    var lijst = (els.upsellRow && els.upsellRow._items) || [];
    return lijst.find(function (p) { return String(p.id) === String(id); });
  }


  /* ------------------------------------------------------------ toevoegen */

  function addToCart(variantId, btn) {
    if (state.busy) return;
    state.busy = true;
    if (btn) btn.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status !== 200) {
          if (data.description || data.message) alert(data.description || data.message);
          return;
        }
        // Laat het thema de lade opnieuw opbouwen (en openen als hij dicht was).
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      })
      .catch(function () {})
      .then(function () {
        state.busy = false;
        if (btn) btn.classList.remove('is-busy');
      });
  }

  if (els.upsellRow) {
    // Keuze gewijzigd: opnieuw bepalen wat nog combineerbaar is.
    els.upsellRow.addEventListener('change', function (evt) {
      var sel = evt.target.closest('[data-emsc-opt]');
      if (!sel) return;
      var kaart = sel.closest('.emsc-up');
      var p = findProduct(kaart.dataset.emscId);
      if (p) ververOpties(kaart, p);
    });

    els.upsellRow.addEventListener('click', function (evt) {
      var btn = evt.target.closest('[data-emsc-add]');
      if (!btn) return;

      var kaart = btn.closest('.emsc-up');
      var p = findProduct(btn.dataset.emscAdd);
      if (!p) return;

      var variant = variantVan(p, gekozenVan(kaart, p));
      if (!variant) {
        // Niets toevoegen zolang de keuze onvolledig is; wijs aan wat ontbreekt.
        var gekozen = gekozenVan(kaart, p);
        kaart.querySelectorAll('[data-emsc-opt]').forEach(function (sel) {
          sel.classList.toggle('is-vereist', !gekozen[+sel.dataset.emscOpt]);
        });
        var eerste = kaart.querySelector('[data-emsc-opt].is-vereist');
        if (eerste) eerste.focus();
        return;
      }
      addToCart(variant.id, btn);
    });
  }

  if (els.upsellNav) {
    els.upsellNav.addEventListener('click', function (evt) {
      var btn = evt.target.closest('[data-emsc-page]');
      if (!btn) return;
      state.upPage += +btn.dataset.emscPage;
      paintUpsell();
    });
  }

  /* ------------------------------------------------------- regel verwijderen */

  // De prullenbak zet het aantal op 0. Het thema-event cart:quantity kan dit
  // niet: quantityChanged() stopt zelf al bij een falsy hoeveelheid.
  root.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-emsc-remove]');
    if (!btn) return;
    evt.preventDefault();
    if (state.busy) return;

    state.busy = true;
    btn.classList.add('is-busy');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: btn.dataset.emscRemove, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var wrapper = root.querySelector('.drawer__contents');
        if (wrapper) wrapper.parentNode.classList.toggle('is-empty', cart.item_count === 0);
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {})
      .then(function () {
        state.busy = false;
        btn.classList.remove('is-busy');
      });
  });

  /* ------------------------------------------------------------- refresh  */

  var timer = null;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      getJSON('/cart.js?t=' + Date.now())
        .then(function (cart) {
          renderShipping(cart);
          renderTiers(cart);
          renderUpsell(cart);
        })
        .catch(function () {});
    }, 90);
  }

  document.addEventListener('ajaxProduct:added', refresh);
  document.addEventListener('cart:updated', refresh);

  if (els.products && window.MutationObserver) {
    new MutationObserver(refresh).observe(els.products, { childList: true, subtree: true });
  }

  refresh();
})();
